export const listSummary = [
    {
        id: 1,
        title: 'Descripción del paquete',
        description: 'Paquetito / Balsamo'
    },
    {
        id: 1,
        title: 'Fecha de partida',
        description: '01/11/22'
    },
    {
        id: 1,
        title: 'Fecha de entrega',
        description: '07/08/22'
    },
    {
        id: 1,
        title: 'Nombre recepcionista',
        description: 'Miguel Angel Zicia Osorio'
    },
    {
        id: 1,
        title: 'Precio paquete',
        description: 'S/ 10.00'
    },
    {
        id: 1,
        title: 'Cantidad',
        description: '1'
    },
    {
        id: 1,
        title: 'Hora partida',
        description: '05:30 pm'
    },
    {
        id: 1,
        title: 'Hora entrega',
        description: '09:02 pm'
    },
    {
        id: 1,
        title: 'Número doc recepcionista',
        description: '4209067'
    },
]